/*
Runs code on specific pages.
*/

export function run(routes) {
  console.log('Router.run');
  for (const [routeString, page] of Object.entries(routes)) {
    const regExp = new RegExp(routeString);
    if (regExp.test(document.location.pathname)) {
      page.run();
      break;
    }
  }
}
